module.exports = __webpack_public_path__ + "static/media/icon-call-center.3a662356.svg";